export const getURLWithQueryParams = (
  url: string,
  params: Partial<
    Record<string, string | number | boolean | Array<string | number> | null>
  >,
) => {
  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (!value) continue;

    if (!Array.isArray(value)) {
      queryParams.append(key, value.toString());
      continue;
    }

    value.forEach((arrayValue) => {
      queryParams.append(`${key}[]`, arrayValue.toString());
    });
  }

  return url + "?" + queryParams;
};
